module.exports = __webpack_public_path__ + "img/certed.77401330.png";